import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { SettingsProvider } from '../contexts/SettingsContext';
import SettingsDashboard from '../components/settings/SettingsDashboard';
import { Box, Alert } from '@mui/material';

const Settings: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const { currentSalonId } = useSelector((state: RootState) => state.tenant);

  if (!user) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Please log in to access settings.
        </Alert>
      </Box>
    );
  }

  // For Super Admin, use the user's salonId if no tenant salon is selected
  // For other users, they should always have their salon context
  const salonId = currentSalonId || user.salonId;

  if (!salonId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          No salon selected. Please select a salon to access settings.
        </Alert>
      </Box>
    );
  }

  return (
    <SettingsProvider salonId={salonId}>
      <SettingsDashboard 
        salonId={salonId} 
        userRole={user.role}
      />
    </SettingsProvider>
  );
};

export default Settings;